export default async (axios, searchValue, page, limit, params = {}) => {
    const response = await axios.get('/File/GetDistanceEstimatorListing');

    const { data } = response;

    return {
        metadata: {
            page: 1,
            pages: 1,
        },
        result: data.map(item => ({
            key: item.model,
            label: item.model,
        })),
    };
};
